import $ from 'jquery';
import {TweenMax, Power2, TimelineLite, Linear, Power4, Power0} from "gsap";

function SidetextSlider(selector) {
  this.fadeDistance = 100;
  this.elems = {};
  this.elems.root = $($(selector).get(0));
  this.elems.slides = this.elems.root.find('.sidetext-slide');
  this.elems.arrowLeft = this.elems.root.find('.slider-arrow.left');
  this.elems.arrowRight = this.elems.root.find('.slider-arrow.right');
  this.iterator = {
    firstTime: false,
    max: this.elems.slides.length - 1,
    current: -1
  };
  this.changeCallback = null;
  
  this.bindArrows();
  this.openSlide(0);
  this.initSwipe();
}

SidetextSlider.prototype.bindArrows = function bindArrows() {
  this.elems.arrowLeft.on('click', () => {
    if(this.iterator.current > 0) {
      this.openSlide(this.iterator.current - 1);
    } else {
      this.openSlide(this.iterator.max);
    }
  });

  this.elems.arrowRight.on('click', () => {
    if(this.iterator.current < this.iterator.max) {
      this.openSlide(this.iterator.current + 1);
    } else {
      this.openSlide(0);
    }
  });
};

SidetextSlider.prototype.updateArrowsState = function updateArrowsState() {
  return;
  // console.log('updateArrowsState = ', this.iterator.current, this.iterator.max);
  if(this.iterator.current <= 0) {
    this.elems.arrowLeft.addClass('disabled');
  } else {
    this.elems.arrowLeft.removeClass('disabled');
  }

  if(this.iterator.current >= this.iterator.max) {
    this.elems.arrowRight.addClass('disabled');
  } else {
    this.elems.arrowRight.removeClass('disabled');
  }
};

SidetextSlider.prototype.openSlide = function openSlide(index) {
  let direction = index <= this.iterator.current ? -1 : 1;
  // console.log('openSlide ', index);

  if(this.iterator.current >= 0 && this.iterator.current <= this.iterator.max) {
    let oldSlide = this.elems.slides[this.iterator.current];
    TweenMax.to(
      oldSlide,
      .3,
      { ease: Linear.easeIn, opacity: 0, x: this.fadeDistance * direction * -1, onComplete: () => {
        // console.log('onComplete!!!');
        TweenMax.set(oldSlide, { display: 'none' });
        if(this.changeCallback) this.changeCallback(index);
      } }
    );
  }

  this.iterator.current = index;

  this.updateArrowsState();

  // console.log('updateArrowsState = ', this.iterator.current, this.iterator.max);
  let slide = $(this.elems.slides.get(index));

  if(!slide.length) return;

  TweenMax.set(slide, {display: 'block'});
  TweenMax.fromTo(slide, 1, 
    {opacity: 0,  x: this.fadeDistance * direction},
    {ease: Power2.easeOut, opacity: 1, x: 0}
  );
  TweenMax.fromTo(slide.find('.sidetext-slide-content'), .5,
    {opacity: 0, y: -30 * direction},
    {delay: .6, opacity: 1, y: 0}
  )
};

SidetextSlider.prototype.initSwipe = function initSwipe() {
  let self = this;

  let itemLength = self.elems.slides.length;
  let isMoving = false;

  let stopMoving = () => {
    isMoving = false;
  };

  self.elems.slides.each(function(index) {
    let elItem = $(this);
    let mc = new Hammer(this);
    mc.get('pan').set({ threshold: 100, direction: Hammer.DIRECTION_HORIZONTAL });

    mc.on('panleft', ev => {
      if(!isMoving) {
        isMoving = true;
        self.elems.arrowRight.click();
        setTimeout(stopMoving, 500);
      }
      // if(!isMoving && index < imgLength - 1) {
      //   isMoving = true;
      //   let elNext = self.elems.imgs[index+1];
      //   TweenMax.set(elImg, { position: 'absolute' });
      //   TweenMax.set(elNext, { display: 'block', opacity: 0 });
      //   new TimelineLite()
      //     .to(elImg, .4, { left: '-100%', opacity: 0 })
      //     .fromTo(elNext, .4, { left: '100%', opacity: 0 }, { left: '0%', opacity: 1, delay: -.25 })
      //     setTimeout(stopMoving, 500);
      // }
    });
    
    mc.on('panright', ev => {
      if(!isMoving) {
        isMoving = true;
        self.elems.arrowLeft.click();
        setTimeout(stopMoving, 500);
      }
      // if(!isMoving && index > 0) {
      //   isMoving = true;
      //   let elPrev = self.elems.imgs[index-1];
      //   TweenMax.set(elImg, { position: 'absolute' });
      //   TweenMax.set(elPrev, { display: 'block', opacity: 0 });
      //   new TimelineLite()
      //     .to(elImg, .5, { left: '100%', opacity: 0 })
      //     .fromTo(elPrev, .5, { left: '-100%', opacity: 0 }, { left: '0%', opacity: 1, delay: -.25 })
      //     setTimeout(stopMoving, 500);
      // }
    });
  });
};

SidetextSlider.prototype.onChange = function onChange(callback) {
  this.changeCallback = callback;
};


export default function(selector) {
  return new SidetextSlider(selector);
};
